/*
 * @Author: jiangfeng
 * @Date: 2021-11-04 20:25:00
 * @LastEditTime: 2021-11-04 20:26:39
 * @LastEditors: jiangfeng
 * @FilePath: /gpux-accept-projects/src/apps/acceptor-center/utils/globalMockData.js
 */
export default {
  mockParams: {}
}
